import React from 'react';

export default translationsStore => ({
  width: '80px',
  className: 'kmLead',
  sorter: (a, b) => a.km - b.km,
  title: (
    <span>
      <div>{translationsStore.translate('lead.table.column.km.km')}</div>
      <div>{translationsStore.translate('lead.table.column.km.lead')}</div>
    </span>
  ),
  dataIndex: 'km'
});
